var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diagnosis-result-detail"},[_c('div',{staticClass:"detail-container"},[_c('div',{staticClass:"detail-content"},[_c('h3',{staticClass:"moudleDefaultTitle"},[_vm._v("诊断结果")]),_c(_vm.getResultDetailComponentBySslCode,{tag:"component",attrs:{"record-id":_vm.diagnosisRecordId}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }